import Select from 'CustomModules/GlobalBPOCore/components/ui/select'
import Dropdown from 'CustomModules/GlobalBPOCore/components/ui/dropdown'
import DropdownV2 from 'CustomModules/GlobalBPOCore/components/ui/v2/dropdown'
import Checkbox from 'CustomModules/GlobalBPOCore/components/ui/v2/checkbox'
import LookupV2 from 'CustomModules/GlobalBPOCore/components/ui/v2/lookup'
import Lookup from 'CustomModules/GlobalBPOCore/components/ui/lookup'
import Datatable from 'CustomModules/GlobalBPOCore/components/ui/datatable'
import Master from 'CustomModules/GlobalBPOCore/components/master-detail/master'
import DescriptionsDetail from 'CustomModules/GlobalBPOCore/components/ui/DescriptionsDetail'
import ShiftsManagementInput from 'CustomModules/GlobalBPOCore/pages/ShiftsManagement/ShiftsManagementInput'
import ScheduledHoursInput from 'CustomModules/GlobalBPOCore/pages/ShiftsManagement/ScheduledHoursInput'
import ExtraShiftModal from 'CustomModules/GlobalBPOCore/pages/ShiftsManagement/ExtraShiftModal'
import InfoNote from 'CustomModules/GlobalBPOCore/components/Dashboard/InfoNote'
import DireccionEstructurada from 'CustomModules/GlobalBPOCore/components/DireccionEstructurada/DireccionEstructurada'
import GestionarRequisicion from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Requisiciones/GestionarRequisicion'
import DetalleDeCandidatos from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Requisiciones/DetalleDeCandidatos'
import CargarCandidatos from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Requisiciones/CargarCandidatos'
import JobsAssets from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Jobs/JobsAssets'
import Encuesta from 'CustomModules/GlobalBPOCore/components/Encuesta/Encuesta'
import ShiftMaster from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Shift/ShiftMaster'
import Evaluados from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Evaluados'
import Evaluadores from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Evaluadores'
import CompetenciasMaster from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Competencias'
import Comportamiento from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Comportamiento'
import NivelCompetencia from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/NivelCompetencia'
import LevelCJob from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/LevelCJob'
import GReportCol from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Greport/GReportCol'
import GReportParamItem from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Greport/GreportParamItem'
import AsigYProc from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Coc/AsigYProc'
import TabGrupos from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Coc/MasterGroups'
import GruposDetail from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Coc/Groups'
import TipoEvaluacion from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/TipoEvaluacion'
import CompetenciaDeRoles from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/CompetenciaDeRoles'
import TipoEvaluador from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/TipoEvaluador'
import Conversion from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Conversion'
import TabsMaestros from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/TabsMaestros'
import ReportParams from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Greport/ReportParams'
import FormsHeaders from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Form/FormsHeaders'
import ActionGroupsItems from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/ActionGroups/ActionGroupsItems'
import JobsAccess from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Jobs/JobsAccess'
import ItemsTaxes from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Fmo/ItemsTaxes'
import InvoicesLines from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Fmo/InvoicesLines'
import InvoicesLinesCtb from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Fmo/InvoicesLinesCtb'
import Totales from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Fmo/Totales'
import FormsCompOptions from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Form/FormsCompOptions'
import MantenimientoPollCategory from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Poll/PollCategory.vue'
import MantenimientoPollQuestion from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Poll/PollQuestion.vue'
import MantenimientoPollQuestionItems from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Poll/PollQuestionItems.vue'
import MantenimientoPollRules from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Poll/PollRules.vue'
import MantenimientoPollRulesActs from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Poll/PollRuleActs.vue'
import MantenimientoPollRulesConds from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Poll/PollRuleConds.vue'
import FormsComponents from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Form/FormsComponents'
import MantenimientoWfApprovalHierarchy
  from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/WfRequest/WfApprovalHierarchy'
import MantenimientoRole from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/Role.vue'
import MantenimientoUserRole from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/UserRole.vue'
import MantenimientoRoleReport from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/RoleReport.vue'
import MantenimientoUserCompany from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/UserCompany.vue'
import MantenimientoLocationUser from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/LocationUser.vue'
import MantenimientoNode from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/Node.vue'
import MantenimientoRoleNodeAction from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/RoleNodeAction.vue'
import MantenimientoAction from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/Action.vue'
import MantenimientoPersonUser from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/PersonUser.vue'
import ListLimpiarHistorial from 'CustomModules/GlobalBPOCore/pages/GReport/ListLimpiarHistorial'
import MantenimientoNodeAction from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/NodeAction.vue'
import EvaluacionesFormularios from 'CustomModules/GlobalBPOCore/pages/Evaluaciones/EvaluacionesFormularios'
import AbsenLiq from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/AbsenLiq.vue'
import AbsenGestion from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/AbsenGestion.vue'
import LawsuitsDetails from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/LawsuitsDetails.vue'
import Vacaciones from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/Vacaciones'
import PeriodoVacaciones from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/PeriodoVacaciones'
import HistoricoVacaciones from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/HistoricoVacaciones'
import BtnHistoricoVacaciones from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/BotonSolicitarVacaciones'
import Ausentismo from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/Ausentismo'
import VacacionesPendientes from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/VacacionesPendientes'
import CreditosAmortizacion from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/CreditosAmortizacion'
import BtnGenerarAmortizacion from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/BotonGenerarAmortizacion'
import UsersByRol from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/UsersByRol.vue'
import ReportByRol from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/ReportByRol.vue'
import NodeChildren from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/NodeChildren.vue'
import CcJobs from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Cc/CcJobs'
import CcOffices from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Cc/CcOffices.vue'
import NodeChildrenLvl2 from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/NodeChildrenLvl2.vue'
import FormPlanoSs2388 from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/FormPlanoSs2388'
import PlanoSs2388 from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/PlanoSs2388'
import SelectNovedades from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/SelectNovedades'
import ChartComponent from 'CustomModules/GlobalBPOCore/pages/Analytics/ChartComponent'
import OcaHist from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/OcaHist'
import CtbHist from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/CtbHist.vue'
import PayrollDetails from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/PayrollDetails.vue'
import PayrollPersonalInfo from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/PayrollPersonalInfo.vue'
import PayrollLabel from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/PayrollLabel.vue'
import PayRollNomCer from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/PayrollNomCer.vue'
import PayrollPersonalInfoCer from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/PayrollPersonalInfoCer.vue'
import PayrollDetailsCer from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/PayrollDetailsCer.vue'
import OvertimeHist from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/OvertimeHist.vue'
import ProgVac from 'CustomModules/GlobalBPOCore/pages/Nomina/Consultas/ProgVac.vue'
import ContractPerson from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadSocial/ContractPerson'
import SeguridadYSaludDetalleTabs from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/DetalleTabs'
import Observaciones from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/Observaciones'
import RecommendCase from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/RecommendCase'
import TracingCase from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/TracingCase'
import InstanceCases from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/InstanceCases'
import DiagnosisInstance from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/DiagnosisInstance'
import AtributosCalendario from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Calendario/AtributosCalendario'
import Documentos from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/Documentos'
import IncapacidadesPresentadas
  from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/IncapacidadesPresentadas'
import RecomendacionesMedicas
  from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/RecomendacionesMedicas'
import AyudasErgonomicas from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/AyudasErgonomicas'
import CasosReportados from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/CasosReportados'
import AccidentesDeTrabajo from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/AccidentesDeTrabajo'
import EmbarazoActual from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/EmbarazoActual'
import VoluntariadoSST from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/VoluntariadoSST'
import LugarDeTrabajo from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/LugarDeTrabajo'
import CoLegalHist from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/CoLegal/CoLegalHist'
import ReportTl from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Report/ReportTl'
import ReportParameter from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Report/ReportParameter'
import DynamicLoadFields from './pages/Mantenimiento/GDynamicLoads/DynamicLoadFields'
import DynamicLoadParams from './pages/Mantenimiento/GDynamicLoads/DynamicLoadParams'
import EquivalencyValues from './pages/Mantenimiento/Equivalency/EquivalencyValues'
import ReportParameterTl from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Report/ReportParameterTl'
import FormProcesoDisciplinario from 'CustomModules/GlobalBPOCore/pages/ReporteNovedad/FormProcesoDisciplinario'
import ProcesosDisciplinarios from 'CustomModules/GlobalBPOCore/pages/ReporteNovedad/ProcesosDisciplinarios'
import PhotoGraphicRecord from 'CustomModules/GlobalBPOCore/pages/ReporteNovedad/PhotoGraphicRecord'
import ModalAprobacionReconocimiento
  from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Reconocimiento/ModalAprobacionReconocimiento'
import ModalCalificacionReconocimientoAnual
  from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Reconocimiento/ModalCalificacionReconocimientoAnual'
import ReconocimientoAnualDetalle
  from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Reconocimiento/ReconocimientoAnualDetalle'
import BtnExcel from 'CustomModules/GlobalBPOCore/components/ui/BtnExcel'
import CargueHistoricoOca from 'CustomModules/GlobalBPOCore/pages/Nomina/CargueMasivo/CargueHistoricoOca'
import CargueOca from 'CustomModules/GlobalBPOCore/pages/Nomina/CargueMasivo/CargueOca'
import wiki from 'CustomModules/GlobalBPOCore/components/ui/wiki'
import ExamenPostincapacidad
  from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/ExamenPostincapacidad'
import CargueDist from 'CustomModules/GlobalBPOCore/pages/Nomina/CargueMasivo/CargueDist'
import CargueHistoricoDist from 'CustomModules/GlobalBPOCore/pages/Nomina/CargueMasivo/CargueHistoricoDist'
import DistributionCcHist from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/DistributionCcHist'
import dropdownLarge from 'CustomModules/GlobalBPOCore/components/ui/dropdownLarge'
import Incapacidades from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/Incapacidades'
import AbsenSst from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/AbsenSst'
import SeguimientoHSEQ from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/SeguimientoHSEQ'
import SeguimientoBienestarSocial from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/SeguimientoBienestarSocial'
import SeguimientoControlInterno from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/SeguimientoControlInterno'
import SeguimientoJuridico from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/SeguimientoJuridico'
import InfoEmpleado from 'CustomModules/GlobalBPOCore/pages/MatrizSeguimiento/InfoEmpleado'
import SkillsGroup from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/SkillsGroup'
import SkillsSubgroup from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/SkillsSubgroup'
import Skill from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Skill'
import SkillJobLevel from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/SkillJobLevel'
import SkillParamItem from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/SkillParamItem'
import Training from 'CustomModules/GlobalBPOCore/pages/Capacitaciones/Training'
import Calendar from 'CustomModules/GlobalBPOCore/pages/Capacitaciones/Calendar'
import StrategicObjective from 'CustomModules/GlobalBPOCore/pages/Capacitaciones/StrategicObjective'
import Competitor from 'CustomModules/GlobalBPOCore/pages/Capacitaciones/Competitors'
import NotasXParticipantes from 'CustomModules/GlobalBPOCore/pages/Capacitaciones/NotasXParticipantes'
import AsistenciaYEvaluacion from 'CustomModules/GlobalBPOCore/pages/Capacitaciones/AsistenciaYEvaluacion'
import PersonasAprobadas from 'CustomModules/GlobalBPOCore/pages/Capacitaciones/PersonasAprobadas'
import MantenimientoUserGroups from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/User/MantenimientoUserGroups'
import InformacionEmpleado from './pages/Dotaciones/InformacionEmpleado'
import PersonRequisitionEvaluator
  from 'CustomModules/GlobalBPOCore/pages/GestionHumana/Requisiciones/PersonRequisitionEvaluator'
import DynamicLoadParamItem from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/GDynamicLoads/DynamicLoadParamItem'
import PCL
  from 'CustomModules/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/PCL'
import Objetivos from './pages/Evaluaciones/Complemento/Objetivos'
import Seguimientos from './pages/Evaluaciones/Complemento/Seguimientos'
import Resultados from './pages/Evaluaciones/Complemento/Resultados'
import EvaCompetencias from './pages/Evaluaciones/Complemento/Competencias'
import EvaCompSeguimiento from './pages/Evaluaciones/Complemento/CompSeguimiento'
import EvaCompResultadosFinales from './pages/Evaluaciones/Complemento/CompResultadoFinal'
import IdentificacionPersonal from './pages/Evaluaciones/Complemento/IdentificacionPersonal'
import IdentificacionPersonalPromocionTraslado
  from './pages/Evaluaciones/Complemento/IdentificacionPersonalPromocionTraslado'
import SignColorPicker from './pages/SignPDF/SignColorPicker'
import SignPdf from 'CustomModules/GlobalBPOCore/pages/SignPDF/SignPdf'

/* Biodata */
import BiodataDatosPersonales from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataDatosPersonales'
import BiodataResumen from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataResumen'
import BiodataOtrosDatosPersonales from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataOtrosDatosPersonales'
import BiodataLicenciasConduccion from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataLicenciasConduccion'
import BiodataCargueDocumentacion from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataCargueDocumentacion'
import BiodataDatosFamiliares from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataDatosFamiliares'
import BiodataOtrosDatosFamiliares from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataOtrosDatosFamiliares'
import BiodataAvisoEnCasoEmergencia from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataAvisoEnCasoEmergencia'
import BiodataInformacionAcademica from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataInformacionAcademica'
import BiodataIdiomaOtrosEstudios from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataIdiomaOtrosEstudios'
import BiodataIdiomaOtrosEstudiosIdiomas
  from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataIdiomaOtrosEstudiosIdiomas'
import BiodataIdiomaOtrosEstudiosNoFormal
  from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataIdiomaOtrosEstudiosNoFormal'
import BiodataCrearPersona from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataCrearPersona'
import BiodataInformacionLaboral from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataInformacionLaboral'
import BiodataReferencias from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataReferencias'
import BiodataOtraInformacionLaboral from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataOtraInformacionLaboral'
import BiodataInformacionBancaria from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataInformacionBancaria'
import BiodataInformacionBancariaInternacional
  from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataInformacionBancariaInternacional'
import BiodataOtrosFormularios from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataOtrosFormularios'
import BiodataConduccion from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataConduccion'
import BiodataCliente from 'CustomModules/GlobalBPOCore/pages/Biodata/BiodataCliente'

/* EMPLEADOS */
import EmployeeDatosPersonales from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeDatosPersonales.vue'
import EmployeeSummary from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeSummary.vue'
import EmployeeSalary from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeSalary.vue'
import EmployeeSocialSecurity from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeSocialSecurity.vue'
import EmployeeSocialSecurityHist from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeSocialSecurityHist.vue'
import EmployeeRetefte from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeRetefte.vue'
import EmployeeRetefteHist from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeRetefteHist.vue'
import EmployeeBank from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeBank.vue'
import InformacionLaboral from 'CustomModules/GlobalBPOCore/pages/Empleados/InformacionLaboral.vue'
import BeneficiosFlexibles from 'CustomModules/GlobalBPOCore/pages/Empleados/BeneficiosFlexibles.vue'
import PayrollControl from 'CustomModules/GlobalBPOCore/pages/Empleados/PayrollControl.vue'
import EmpCentroDeCosto from 'CustomModules/GlobalBPOCore/pages/Empleados/CentroDeCosto.vue'
import EmpAtributos from 'CustomModules/GlobalBPOCore/pages/Empleados/Atributos.vue'
import AttributoCaracterNumerico from 'CustomModules/GlobalBPOCore/pages/Empleados/AttributoCaracterNumerico.vue'
import AttributoHistorico from 'CustomModules/GlobalBPOCore/pages/Empleados/AttributoHistorico.vue'
import AttributoTabs from 'CustomModules/GlobalBPOCore/pages/Empleados/AttributoTabs.vue'
import EmployeeEmpCategory from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeEmpCategory.vue'
import EmployeeBankHist from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeBankHist.vue'
import EmployeeInfoLabTabs from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeInfoLabTabs.vue'
import EmployeeCargo from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeCargo.vue'
import EmployeeOficina from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeOficina.vue'
import EmployeeTipoPago from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeTipoPago.vue'
import EmployeeAttHist from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeAttHist.vue'
import btnCrearContrato from 'CustomModules/GlobalBPOCore/pages/Empleados/btnCrearContrato.vue'
import JobsCompetency from 'CustomModules/GlobalBPOCore/pages/Mantenimiento/Jobs/JobsCompetency.vue'
import EmployeeReenganche from 'CustomModules/GlobalBPOCore/pages/Empleados/EmployeeReenganche.vue'
import Sanciones from 'CustomModules/GlobalBPOCore/pages/Empleados/Sanciones.vue'
import ActionGroup from 'CustomModules/GlobalBPOCore/components/ActionGroups/ActionGroup'
import DotacionesEmpleado from './pages/Dotaciones/DotacionesEmpleado'
import GarmentSizeDot from './pages/Mantenimiento/Dotaciones/GarmentSizeDot'

import DynamicLoadRunModal from './pages/DynamicLoads/DynamicLoadRunModal'
import DynamicLoadStatusModal from './pages/DynamicLoads/DynamicLoadStatusModal'
import NomElectNodos from './pages/Mantenimiento/NomElect/NomElectNodos'
import AtributosLaborales from './pages/Empleados/AtributosLaborales'

import CargueDinamicoOcasionales from 'CustomModules/GlobalBPOCore/pages/Nomina/Novedades/CargueDinamicoOcasionales.vue'

/* CARGUE MASIVO PRORROGAS */
import CargueProrrogas from './pages/GestionHumana/Prorrogas/CargueMasivo/CargueProrrogas'
import EmployeeCargueDocDesvinculacion from './pages/Empleados/EmployeeCargueDocDesvinculacion'
import EmployeeRetefteDeduPendiente from './pages/Empleados/EmployeeRetefteDeduPendiente'

// GESTION DE PROYECTOS
import ProjectPersonas from './pages/Mantenimiento/GestionDeProyectos/ProjectPersonas'
import ProjectTasks from './pages/Mantenimiento/GestionDeProyectos/ProjectTasks'
import ProjectTaskDetails from './pages/Mantenimiento/GestionDeProyectos/ProjectTaskDetails'
import ProjectTaskPersonAdmin from './pages/Mantenimiento/GestionDeProyectos/ProjectTaskPersonAdmin'
import ProjectTaskPerson from './pages/Mantenimiento/GestionDeProyectos/ProjectTaskPerson'
//

import OvertimeLiqCer from './pages/OvertimeTurn/OvertimeLiqCer'
import OvertimeLiqDetails from './pages/OvertimeTurn/OvertimeLiqDetails'
import EMODetails from './pages/MatrizSeguimiento/EMODetails'
import LiqMarcDetails from './pages/LiqMarc/LiqMarcDetails'
import LiqMarcCer from './pages/LiqMarc/LiqMarcCer'
import CentroDeCostoOracle from './pages/Empleados/CentroDeCostoOracle'

// MARCACIONES GEO
import MarcacionGeo from '../SelfService/pages/Dashboard/MarcacionGeo'
import CesparLocApprov from './pages/Mantenimiento/WfRequest/CesparLocApprov'

export const Components = [
  {name: 'g-select', component: Select},
  {name: 'dynamic-load-run-modal', component: DynamicLoadRunModal},
  {name: 'dynamic-load-status-modal', component: DynamicLoadStatusModal},
  {name: 'g-dropdown', component: Dropdown},
  {name: 'form-model-dropdown', component: DropdownV2},
  {name: 'form-model-checkbox', component: Checkbox},
  {name: 'form-model-lookup', component: LookupV2},
  {name: 'g-lookup', component: Lookup},
  {name: 'g-datatable', component: Datatable},
  {name: 'g-master', component: Master},
  {name: 'g-descriptions-detail', component: DescriptionsDetail},
  {name: 'g-btn-excel', component: BtnExcel},
  {name: 'sm-input', component: ShiftsManagementInput},
  {name: 'sh-input', component: ScheduledHoursInput},
  {name: 'modal-extra-shifts', component: ExtraShiftModal},
  {name: 'info-note', component: InfoNote},
  {name: 'direccion-estructurada', component: DireccionEstructurada},
  {name: 'gestionar-requisicion', component: GestionarRequisicion},
  {name: 'modal-cargar-candidatos-requisicion', component: CargarCandidatos},
  {name: 'jobs-assets', component: JobsAssets},
  {name: 'detalle-de-candidatos-requisicion', component: DetalleDeCandidatos},
  {name: 'encuesta-component', component: Encuesta},
  {name: 'shift-master', component: ShiftMaster},
  {name: 'evaluados', component: Evaluados},
  {name: 'evaluadores', component: Evaluadores},
  {name: 'nivel-competencia', component: NivelCompetencia},
  {name: 'level-c-job', component: LevelCJob},
  {name: 'comportamiento', component: Comportamiento},
  {name: 'competencias', component: CompetenciasMaster},
  {name: 'comportamiento', component: Comportamiento},
  {name: 'tipoevaluacion', component: TipoEvaluacion},
  {name: 'competenciaderoles', component: CompetenciaDeRoles},
  {name: 'tipoevaluador', component: TipoEvaluador},
  {name: 'conversion', component: Conversion},
  {name: 'tabsmaestros', component: TabsMaestros},
  {name: 'reportparams', component: ReportParams},
  {name: 'greportcol', component: GReportCol},
  {name: 'comportamiento', component: Comportamiento},
  {name: 'greportparaitem', component: GReportParamItem},
  {name: 'tabgrupos', component: TabGrupos},
  {name: 'asigyproc', component: AsigYProc},
  {name: 'gruposdetail', component: GruposDetail},
  {name: 'encuesta-component', component: Encuesta},
  {name: 'biodata-datos-personales', component: BiodataDatosPersonales},
  {name: 'biodata-resumen', component: BiodataResumen},
  {name: 'biodata-otros-datos-personales', component: BiodataOtrosDatosPersonales},
  {name: 'biodata-licencias-conduccion', component: BiodataLicenciasConduccion},
  {name: 'biodata-cargue-documentacion', component: BiodataCargueDocumentacion},
  {name: 'biodata-datos-familiares', component: BiodataDatosFamiliares},
  {name: 'biodata-otros-datos-familiares', component: BiodataOtrosDatosFamiliares},
  {name: 'biodata-aviso-en-caso-emergencia', component: BiodataAvisoEnCasoEmergencia},
  {name: 'biodata-informacion-academica', component: BiodataInformacionAcademica},
  {name: 'biodata-idioma-otros-estudios', component: BiodataIdiomaOtrosEstudios},
  {name: 'biodata-idioma-otros-estudios-idiomas', component: BiodataIdiomaOtrosEstudiosIdiomas},
  {name: 'biodata-idioma-otros-estudios-no-formal', component: BiodataIdiomaOtrosEstudiosNoFormal},
  {name: 'biodata-crear-persona', component: BiodataCrearPersona},
  {name: 'biodata-informacion-laboral', component: BiodataInformacionLaboral},
  {name: 'biodata-referencias', component: BiodataReferencias},
  {name: 'biodata-otra-informacion-laboral', component: BiodataOtraInformacionLaboral},
  {name: 'biodata-informacion-bancaria', component: BiodataInformacionBancaria},
  {name: 'biodata-informacion-bancaria-internacional', component: BiodataInformacionBancariaInternacional},
  {name: 'biodata-otros-formularios', component: BiodataOtrosFormularios},
  {name: 'forms_headers', component: FormsHeaders},
  {name: 'action_groups_items', component: ActionGroupsItems},
  {name: 'jobs-access', component: JobsAccess},
  {name: 'items_taxes', component: ItemsTaxes},
  {name: 'invoices_lines', component: InvoicesLines},
  {name: 'invoices_lines_ctb', component: InvoicesLinesCtb},
  {name: 'invoices_totales', component: Totales},
  {name: 'mantenimiento-poll-category', component: MantenimientoPollCategory},
  {name: 'mantenimiento-poll-question', component: MantenimientoPollQuestion},
  {name: 'mantenimiento-poll-question-items', component: MantenimientoPollQuestionItems},
  {name: 'mantenimiento-poll-rules', component: MantenimientoPollRules},
  {name: 'mantenimiento-poll-rule-acts', component: MantenimientoPollRulesActs},
  {name: 'mantenimiento-poll-rule-conds', component: MantenimientoPollRulesConds},
  {name: 'forms_components', component: FormsComponents},
  {name: 'forms-comp-options', component: FormsCompOptions},
  {name: 'wf-approval-hierarchy', component: MantenimientoWfApprovalHierarchy},
  {name: 'mantenimiento-role', component: MantenimientoRole},
  {name: 'mantenimiento-user-role', component: MantenimientoUserRole},
  {name: 'mantenimiento-role-report', component: MantenimientoRoleReport},
  {name: 'mantenimiento-user-company', component: MantenimientoUserCompany},
  {name: 'mantenimiento-location-user', component: MantenimientoLocationUser},
  {name: 'mantenimiento-node', component: MantenimientoNode},
  {name: 'mantenimiento-role-node-action', component: MantenimientoRoleNodeAction},
  {name: 'mantenimiento-action', component: MantenimientoAction},
  {name: 'mantenimiento-person-user', component: MantenimientoPersonUser},
  {name: 'employee-datos-personales', component: EmployeeDatosPersonales},
  {name: 'employee-summary', component: EmployeeSummary},
  {name: 'employee-salary', component: EmployeeSalary},
  {name: 'employee-social-security', component: EmployeeSocialSecurity},
  {name: 'employee-social-security-hist', component: EmployeeSocialSecurityHist},
  {name: 'employee-retefte', component: EmployeeRetefte},
  {name: 'employee-retefte-hist', component: EmployeeRetefteHist},
  {name: 'employee-bank', component: EmployeeBank},
  {name: 'informacion-laboral', component: InformacionLaboral},
  {name: 'beneficios-flexibles', component: BeneficiosFlexibles},
  {name: 'payroll-control', component: PayrollControl},
  {name: 'emp-centro-costo', component: EmpCentroDeCosto},
  {name: 'emp-atributos', component: EmpAtributos},
  {name: 'attributo-caracter-numerico', component: AttributoCaracterNumerico},
  {name: 'attributo-historico', component: AttributoHistorico},
  {name: 'attributo-tabs', component: AttributoTabs},
  {name: 'employee-emp-category', component: EmployeeEmpCategory},
  {name: 'mantenimiento-node-action', component: MantenimientoNodeAction},
  {name: 'employee-bank-hist', component: EmployeeBankHist},
  {name: 'employee-infolab-tabs', component: EmployeeInfoLabTabs},
  {name: 'employee-cargo', component: EmployeeCargo},
  {name: 'employee-oficina', component: EmployeeOficina},
  {name: 'employee-tipo-pago', component: EmployeeTipoPago},
  {name: 'employee-att-hist', component: EmployeeAttHist},
  {name: 'biodata-conduccion', component: BiodataConduccion},
  {name: 'list-limpiar-historial', component: ListLimpiarHistorial},
  {name: 'formularios-evaluacion', component: EvaluacionesFormularios},
  {name: 'absen-liq', component: AbsenLiq},
  {name: 'absen-gestion', component: AbsenGestion},
  {name: 'lawsuits-details', component: LawsuitsDetails},
  {name: 'formularios-evaluacion', component: EvaluacionesFormularios},
  {name: 'list-limpiar-historial', component: ListLimpiarHistorial},
  {name: 'vacaciones', component: Vacaciones},
  {name: 'periodo-vacaciones', component: PeriodoVacaciones},
  {name: 'historico-vacaciones', component: HistoricoVacaciones},
  {name: 'ausentismo', component: Ausentismo},
  {name: 'btn-historico-vacaciones', component: BtnHistoricoVacaciones},
  {name: 'vacaciones-pendientes', component: VacacionesPendientes},
  {name: 'creditos-amortizacion', component: CreditosAmortizacion},
  {name: 'btn-generar-amortizacion', component: BtnGenerarAmortizacion},
  {name: 'lawsuits-details', component: LawsuitsDetails},
  {name: 'mantenimiento-usuarios-por-rol', component: UsersByRol},
  {name: 'mantenimiento-reportes-por-rol', component: ReportByRol},
  {name: 'mantenimiento-node-children', component: NodeChildren},
  {name: 'cc-jobs', component: CcJobs},
  {name: 'cc-offices', component: CcOffices},
  {name: 'biodata-cliente', component: BiodataCliente},
  {name: 'mantenimiento-node-children-lvl2', component: NodeChildrenLvl2},
  {name: 'btn-crear-contrato', component: btnCrearContrato},
  {name: 'form-plano-ss-2388', component: FormPlanoSs2388},
  {name: 'plano-ss-2388', component: PlanoSs2388},
  {name: 'select-novedades', component: SelectNovedades},
  {name: 'btn-crear-contrato', component: btnCrearContrato},
  {name: 'analytics-chart-component', component: ChartComponent},
  {name: 'oca-hist', component: OcaHist},
  {name: 'btn-crear-contrato', component: btnCrearContrato},
  {name: 'ctb-hist', component: CtbHist},
  {name: 'payroll-details', component: PayrollDetails},
  {name: 'payroll-label', component: PayrollLabel},
  {name: 'payroll-personal-info', component: PayrollPersonalInfo},
  {name: 'payroll-nom-cer', component: PayRollNomCer},
  {name: 'payroll-personal-info-cer', component: PayrollPersonalInfoCer},
  {name: 'payroll-details-cer', component: PayrollDetailsCer},
  {name: 'overtime-hist', component: OvertimeHist},
  {name: 'prog-vac', component: ProgVac},
  {name: 'contract-person', component: ContractPerson},
  {name: 'seguridad-salud-detalle-tabs', component: SeguridadYSaludDetalleTabs},
  {name: 'seguridad-salud-observaciones', component: Observaciones},
  {name: 'seguridad-salud-recommendcase', component: RecommendCase},
  {name: 'seguridad-salud-tracingcase', component: TracingCase},
  {name: 'seguridad-salud-instance-cases', component: InstanceCases},
  {name: 'seguridad-salud-diagnosis-instance', component: DiagnosisInstance},
  {name: 'jobs-competency', component: JobsCompetency},
  {name: 'atributos-calendario', component: AtributosCalendario},
  {name: 'contract-person', component: ContractPerson},
  {name: 'documentos', component: Documentos},
  {name: 'incapacidades-presentadas', component: IncapacidadesPresentadas},
  {name: 'recomendaciones-medicas', component: RecomendacionesMedicas},
  {name: 'ayudas-ergonomicas', component: AyudasErgonomicas},
  {name: 'casos-reportados', component: CasosReportados},
  {name: 'accidentes-trabajo', component: AccidentesDeTrabajo},
  {name: 'embarazo-actual', component: EmbarazoActual},
  {name: 'voluntariado-sst', component: VoluntariadoSST},
  {name: 'lugar-de-trabajo', component: LugarDeTrabajo},
  {name: 'co-legal-hist', component: CoLegalHist},
  {name: 'employee-reenganche', component: EmployeeReenganche},
  {name: 'report-tl', component: ReportTl},
  {name: 'report-parameter', component: ReportParameter},
  {name: 'dynamic-load-fields', component: DynamicLoadFields},
  {name: 'dynamic-load-params', component: DynamicLoadParams},
  {name: 'equivalency-values', component: EquivalencyValues},
  {name: 'report-parameter-tl', component: ReportParameterTl},
  {name: 'action-group', component: ActionGroup},
  {name: 'employee-reenganche', component: EmployeeReenganche},
  {name: 'documentos', component: Documentos},
  {name: 'form-proceso-disciplinario', component: FormProcesoDisciplinario},
  {name: 'procesos-disciplinarios', component: ProcesosDisciplinarios},
  {name: 'photo-graphic-record', component: PhotoGraphicRecord},
  {name: 'modal-aprobacion-reconocimiento', component: ModalAprobacionReconocimiento},
  {name: 'modal-calificacion-reconocimiento', component: ModalCalificacionReconocimientoAnual},
  {name: 'reconocimiento-anual-detalle', component: ReconocimientoAnualDetalle},
  {name: 'cargue-historico-oca', component: CargueHistoricoOca},
  {name: 'cargue_oca', component: CargueOca},
  {name: 'employee-sanciones', component: Sanciones},
  {name: 'g-wiki', component: wiki},
  {name: 'seguridad-salud-examen-postincapacidad', component: ExamenPostincapacidad},
  {name: 'cargue-dist', component: CargueDist},
  {name: 'cargue-historico-dist', component: CargueHistoricoDist},
  {name: 'distribution-cc-hist', component: DistributionCcHist},
  {name: 'dropdown-large', component: dropdownLarge},
  {name: 'seguimiento-incapacidades', component: Incapacidades},
  {name: 'absen-sst', component: AbsenSst},
  {name: 'seguimiento-hseq', component: SeguimientoHSEQ},
  {name: 'seguimiento-bienestar-social', component: SeguimientoBienestarSocial},
  {name: 'seguimiento-control-interno', component: SeguimientoControlInterno},
  {name: 'seguimiento-juridico', component: SeguimientoJuridico},
  {name: 'info-empleado', component: InfoEmpleado},
  {name: 'skills-group', component: SkillsGroup},
  {name: 'skill-subgroup', component: SkillsSubgroup},
  {name: 'skill', component: Skill},
  {name: 'skill-job-level', component: SkillJobLevel},
  {name: 'skill-param-item', component: SkillParamItem},
  {name: 'info-empleado', component: InfoEmpleado},
  {name: 'training', component: Training},
  {name: 'calendar', component: Calendar},
  {name: 'strategic-objectives', component: StrategicObjective},
  {name: 'competitor', component: Competitor},
  {name: 'notas-participantes', component: NotasXParticipantes},
  {name: 'asistencia-evaluacion', component: AsistenciaYEvaluacion},
  {name: 'personas-aprobadas', component: PersonasAprobadas},
  {name: 'mantenimiento-user-groups', component: MantenimientoUserGroups},
  {name: 'informacion-empleado', component: InformacionEmpleado},
  {name: 'dotaciones', component: DotacionesEmpleado},
  {name: 'garment_size_dot', component: GarmentSizeDot},
  {name: 'mantenimiento-user-groups', component: MantenimientoUserGroups},
  {name: 'person-requisition-evaluator', component: PersonRequisitionEvaluator},
  {name: 'dynamic-load-param-item', component: DynamicLoadParamItem},
  {name: 'nomina-elect-nodos', component: NomElectNodos},
  {name: 'cargue_prorogation', component: CargueProrrogas},
  {name: 'pcl', component: PCL},
  {name: 'eva_objetivos', component: Objetivos},
  {name: 'eva_seguimiento', component: Seguimientos},
  {name: 'eva_resultados_finales', component: Resultados},
  {name: 'eva_competencias', component: EvaCompetencias},
  {name: 'eva_comp_seguimiento', component: EvaCompSeguimiento},
  {name: 'eva_comp_resultados_finales', component: EvaCompResultadosFinales},
  {name: 'identificacion-personal', component: IdentificacionPersonal},
  {name: 'personal_prom_traslado', component: IdentificacionPersonalPromocionTraslado},
  {name: 'employee-cargue-doc-desvinculacion', component: EmployeeCargueDocDesvinculacion},
  {name: 'employee-deduccion-dependiente', component: EmployeeRetefteDeduPendiente},
  {name: 'atributo-laborales', component: AtributosLaborales},
  {name: 'project_personas', component: ProjectPersonas},
  {name: 'project_tasks', component: ProjectTasks},
  {name: 'project_task_details', component: ProjectTaskDetails},
  {name: 'project_task_person', component: ProjectTaskPerson},
  {name: 'project_task_person_admin', component: ProjectTaskPersonAdmin},
  {name: 'overtime-liq-cer', component: OvertimeLiqCer},
  {name: 'overtime-details', component: OvertimeLiqDetails},
  {name: 'emo-details', component: EMODetails},
  {name: 'liqmarc-details', component: LiqMarcDetails},
  {name: 'liqmarc-cer', component: LiqMarcCer},
  {name: 'centro-de-costo-oracle', component: CentroDeCostoOracle},
  {name: 'sign-color-picker', component: SignColorPicker},
  {name: 'sign-pdf', component: SignPdf},
  {name: 'marcacion-geo', component: MarcacionGeo},
  {name: 'sign-pdf', component: SignPdf},
  {name: 'cargue-dinamico-ocasionales', component: CargueDinamicoOcasionales},
  {name: 'cespar-loc-approv', component: CesparLocApprov}
]



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/components.js